
/**
 * Determines if the installation requires multiple units based on room count and area
 */
export function determineIfMultipleUnitsNeeded(rooms: number, area: number): boolean {
  // Ensure we're working with numbers
  const roomCount = Number(rooms);
  const squareArea = Number(area);
  
  console.log("determineIfMultipleUnitsNeeded called with:", { rooms, roomCount, area, squareArea });
  
  // Logic to determine if multiple units are needed:
  // - More than 2 rooms typically needs multiple units
  // - Large areas (>60 sq meters) typically need multiple units
  const result = roomCount > 2 || squareArea > 60;
  console.log("determineIfMultipleUnitsNeeded result:", result);
  
  return result;
}

/**
 * Gets available time slots based on whether multiple units are needed
 */
export function getAvailableTimeSlots(needsMultipleUnits: boolean): string[] {
  console.log("getAvailableTimeSlots called with needsMultipleUnits:", needsMultipleUnits);
  
  const result = needsMultipleUnits 
    ? ['08:00 - 16:00'] // Full day slot for multiple units
    : [
        '08:00 - 12:00',
        '12:00 - 16:00',
      ];
      
  console.log("getAvailableTimeSlots returning:", result);
  
  return result;
}

/**
 * Gets estimated installation duration based on room count, area, and offer type
 */
export function getEstimatedInstallationDuration(
  rooms: number, 
  area: number, 
  offerType: 'standard' | 'premium' | 'exclusive'
): string {
  // Ensure we're working with numbers
  const roomCount = Number(rooms);
  const squareArea = Number(area);
  const needsMultipleUnits = determineIfMultipleUnitsNeeded(roomCount, squareArea);

  console.log("getEstimatedInstallationDuration called with:", { rooms, area, offerType });
  console.log("needsMultipleUnits:", needsMultipleUnits);
  
  const result = needsMultipleUnits ? '6-8 godzin' : '3-4 godziny';
  console.log("getEstimatedInstallationDuration returning:", result);
  
  return result;
}
